import { getCurrentDensity } from 'owa-fabric-densities';
import { changeDensity } from 'owa-fabric-theme';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';
import { isHostAppFeatureEnabled } from 'owa-hostapp-feature-flags';
import { getOpxHostApi } from 'owa-opx';
import type DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';
import { getUserDisplayDensityMode } from 'owa-session-store';

export default async function initializeDensity(): Promise<void> {
    const defaultDensityMode = 'Full';
    if (isHostAppFeatureEnabled('loadThemeFromHostApp')) {
        // preserve legacy density behavior in OPX (always Full) instead of referencing user setting,
        // which could lead to unexpected changes that are incompatible with existing host-app expecations
        //
        // host apps can optionally specify a preferred density, which will take precedence over the default
        const opxHostApi = getOpxHostApi();
        opxHostApi.registerThemeChangedHandler(
            (_isDarkTheme: boolean, densityMode: DisplayDensityMode | undefined) => {
                internalLoadDensity(densityMode || defaultDensityMode);
            }
        );

        internalLoadDensity((await opxHostApi.getOpxDensityMode()) || defaultDensityMode);
    } else if (
        isHostAppFeatureEnabled('useTeamsAppearance') &&
        !isGlobalFeatureEnabled('platform-disableHostAppSpecificCustomizations')
    ) {
        /**
         * @TODO: Set proper density based on hub's density.
         * Currently, as there is no such information available from MetaOS context, setting the density to 'Full' by default.
         */
        internalLoadDensity(defaultDensityMode);
    } else {
        // reference user setting for preferred density
        internalLoadDensity(getUserDisplayDensityMode() || defaultDensityMode);
    }
}

function internalLoadDensity(selectedDensityMode: DisplayDensityMode) {
    changeDensity(selectedDensityMode, getCurrentDensity(selectedDensityMode));
}
